import React, { useState, Fragment } from 'react';
import {
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  FormGroup,
  FormFeedback,
} from 'reactstrap';
import IntlMessages from "../../../../../helpers/IntlMessages";
import { Colxx } from '../../../../../components/common/CustomBootstrap';

import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { postAPI_Update_Restrictions, gAPI_RatesPlan_List_ByRoomId } from '../../../../../constants/APIs';

// Redux
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Validation from '../../../../../components/Validation';

import { Formik, FieldArray, Form } from 'formik';
import * as Yup from 'yup';

// ✅ Yup schema
const RestrictionSchema = Yup.object().shape({
  restrictions: Yup.array().of(
    Yup.object().shape({
      roomTypeId: Yup.string().required('Choose the room type!'),
      ratePlanId: Yup.string().required('Choose the rate plan!'),
      startDate: Yup.date().required('Choose the start date!'),
      endDate: Yup.date().required('Choose the end date!'),
      maximumLengthOfStay: Yup.number().min(0).required('Enter max stay'),
      minimumLengthOfStay: Yup.number().min(0).required('Enter min stay'),
      stopSell: Yup.boolean().required(),
      closedArrival: Yup.boolean().required(),
      closedDeparture: Yup.boolean().required(),
    })
  ),
});

function RestrictionsEditModal({ isVisible, toggleModal, propertyId, roomlist }) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [ratePlanlist, setRatePlanlist] = useState([]);

  const handleUpdate = (values) => {
    AxiosAPI({
      url: postAPI_Update_Restrictions,
      method: 'post',
      data: {
        propertyId,
        data: values.restrictions,
      },
    })
      .then((res) => {
        if (
          res.data.HttpStatusCode === 400 &&
          res.data.Messages &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  return (
    <div>
      <Modal size="lg" isOpen={isVisible} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit Restrictions</ModalHeader>

        <Formik
          initialValues={{
            restrictions: [
              {
                roomTypeId: '',
                ratePlanId: '',
                startDate: '',
                endDate: '',
                maximumLengthOfStay: 0,
                minimumLengthOfStay: 0,
                stopSell: false,
                closedArrival: false,
                closedDeparture: false,
              },
            ],
          }}
          validationSchema={RestrictionSchema}
          onSubmit={handleUpdate}
        >
          {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
            <Form>
              <ModalBody>
                <FieldArray
                  name="restrictions"
                  render={(arrayHelpers) => (
                    <>
                      {values.restrictions.map((field, index) => (
                        <Fragment key={index}>
                          <Row>
                            {/* Room Type */}
                            <Colxx sm={3}>
                              <FormGroup>
                                <Label><IntlMessages id="dashboards.room-type" /></Label>
                                <Input
                                  type="select"
                                  name={`restrictions.${index}.roomTypeId`}
                                  value={field.roomTypeId}
                                  onChange={(e) => {
                                    handleChange(e);
                                    AxiosAPI({
                                      method: 'get',
                                      url: `${gAPI_RatesPlan_List_ByRoomId}?roomId=${e.target.value}&status=1`,
                                    })
                                      .then((res) => {
                                        const list = res.data.ratePlans.map((elem) => ({
                                          ratePlanId: elem.id,
                                          ratePlanName: elem.name,
                                        }));
                                        setRatePlanlist(list);
                                      })
                                      .catch((err) => console.log(err));
                                  }}
                                  onBlur={handleBlur}
                                  invalid={
                                    !!(errors.restrictions?.[index]?.roomTypeId &&
                                    touched.restrictions?.[index]?.roomTypeId)
                                  }
                                >
                                  <option value="" disabled hidden>
                                    Room Type
                                  </option>
                                  {roomlist.map((elem) => (
                                    <option value={elem.roomTypeId} key={elem.roomTypeId}>
                                      {elem.roomName}
                                    </option>
                                  ))}
                                </Input>
                                {errors.restrictions?.[index]?.roomTypeId &&
                                  touched.restrictions?.[index]?.roomTypeId && (
                                    <FormFeedback>{errors.restrictions[index].roomTypeId}</FormFeedback>
                                  )}
                              </FormGroup>
                            </Colxx>

                            {/* Rate Plan */}
                            <Colxx sm={3}>
                              <FormGroup>
                                <Label>Rate Plan</Label>
                                <Input
                                  type="select"
                                  name={`restrictions.${index}.ratePlanId`}
                                  value={field.ratePlanId}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  invalid={
                                    !!(errors.restrictions?.[index]?.ratePlanId &&
                                    touched.restrictions?.[index]?.ratePlanId)
                                  }
                                >
                                  <option value="" disabled hidden>
                                    Rate Plan
                                  </option>
                                  {ratePlanlist.map((elem) => (
                                    <option value={elem.ratePlanId} key={elem.ratePlanId}>
                                      {elem.ratePlanName}
                                    </option>
                                  ))}
                                </Input>
                                {errors.restrictions?.[index]?.ratePlanId &&
                                  touched.restrictions?.[index]?.ratePlanId && (
                                    <FormFeedback>{errors.restrictions[index].ratePlanId}</FormFeedback>
                                  )}
                              </FormGroup>
                            </Colxx>

                            {/* Start Date */}
                            <Colxx sm={3}>
                              <FormGroup>
                                <Label><IntlMessages id="dashboards.start-date" /></Label>
                                <Input
                                  type="date"
                                  name={`restrictions.${index}.startDate`}
                                  value={field.startDate}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  invalid={
                                    !!(errors.restrictions?.[index]?.startDate &&
                                    touched.restrictions?.[index]?.startDate)
                                  }
                                />
                                {errors.restrictions?.[index]?.startDate &&
                                  touched.restrictions?.[index]?.startDate && (
                                    <FormFeedback>{errors.restrictions[index].startDate}</FormFeedback>
                                  )}
                              </FormGroup>
                            </Colxx>

                            {/* End Date */}
                            <Colxx sm={3}>
                              <FormGroup>
                                <Label><IntlMessages id="dashboards.end-date" /></Label>
                                <Input
                                  type="date"
                                  name={`restrictions.${index}.endDate`}
                                  value={field.endDate}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  invalid={
                                    !!(errors.restrictions?.[index]?.endDate &&
                                    touched.restrictions?.[index]?.endDate)
                                  }
                                />
                                {errors.restrictions?.[index]?.endDate &&
                                  touched.restrictions?.[index]?.endDate && (
                                    <FormFeedback>{errors.restrictions[index].endDate}</FormFeedback>
                                  )}
                              </FormGroup>
                            </Colxx>

                            {/* Max Stay */}
                            <Colxx sm={2}>
                              <FormGroup>
                                <Label>Max Stay</Label>
                                <Input
                                  type="number"
                                  name={`restrictions.${index}.maximumLengthOfStay`}
                                  value={field.maximumLengthOfStay}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  min={0}
                                  invalid={
                                    !!(errors.restrictions?.[index]?.maximumLengthOfStay &&
                                    touched.restrictions?.[index]?.maximumLengthOfStay)
                                  }
                                />
                                {errors.restrictions?.[index]?.maximumLengthOfStay &&
                                  touched.restrictions?.[index]?.maximumLengthOfStay && (
                                    <FormFeedback>{errors.restrictions[index].maximumLengthOfStay}</FormFeedback>
                                  )}
                              </FormGroup>
                            </Colxx>

                            {/* Min Stay */}
                            <Colxx sm={2}>
                              <FormGroup>
                                <Label>Min Stay</Label>
                                <Input
                                  type="number"
                                  name={`restrictions.${index}.minimumLengthOfStay`}
                                  value={field.minimumLengthOfStay}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  min={0}
                                  invalid={
                                    !!(errors.restrictions?.[index]?.minimumLengthOfStay &&
                                    touched.restrictions?.[index]?.minimumLengthOfStay)
                                  }
                                />
                                {errors.restrictions?.[index]?.minimumLengthOfStay &&
                                  touched.restrictions?.[index]?.minimumLengthOfStay && (
                                    <FormFeedback>{errors.restrictions[index].minimumLengthOfStay}</FormFeedback>
                                  )}
                              </FormGroup>
                            </Colxx>

                            {/* Stop Sell */}
                            <Colxx sm={2}>
                              <FormGroup>
                                <Label>Stop Sell?</Label>
                                <Input
                                  type="select"
                                  name={`restrictions.${index}.stopSell`}
                                  value={field.stopSell}
                                  onChange={(e) =>
                                    setFieldValue(
                                      `restrictions.${index}.stopSell`,
                                      e.target.value === 'true'
                                    )
                                  }
                                  onBlur={handleBlur}
                                >
                                  <option value={false}>No</option>
                                  <option value={true}>Yes</option>
                                </Input>
                              </FormGroup>
                            </Colxx>

                            {/* Closed for Arrival */}
                            <Colxx sm={3}>
                              <FormGroup>
                                <Label>Closed for Arrival?</Label>
                                <Input
                                  type="select"
                                  name={`restrictions.${index}.closedArrival`}
                                  value={field.closedArrival}
                                  onChange={(e) =>
                                    setFieldValue(
                                      `restrictions.${index}.closedArrival`,
                                      e.target.value === 'true'
                                    )
                                  }
                                  onBlur={handleBlur}
                                >
                                  <option value={false}>No</option>
                                  <option value={true}>Yes</option>
                                </Input>
                              </FormGroup>
                            </Colxx>

                            {/* Closed for Departure */}
                            <Colxx sm={3}>
                              <FormGroup>
                                <Label>Closed for Departure?</Label>
                                <Input
                                  type="select"
                                  name={`restrictions.${index}.closedDeparture`}
                                  value={field.closedDeparture}
                                  onChange={(e) =>
                                    setFieldValue(
                                      `restrictions.${index}.closedDeparture`,
                                      e.target.value === 'true'
                                    )
                                  }
                                  onBlur={handleBlur}
                                >
                                  <option value={false}>No</option>
                                  <option value={true}>Yes</option>
                                </Input>
                              </FormGroup>
                            </Colxx>

                            {/* Add/Remove */}
                            <Colxx sm={4} className="mb-3">
                              <div>
                                <Button
                                  style={{ margin: '6px' }}
                                  onClick={() =>
                                    arrayHelpers.push({
                                      roomTypeId: '',
                                      ratePlanId: '',
                                      startDate: '',
                                      endDate: '',
                                      maximumLengthOfStay: 0,
                                      minimumLengthOfStay: 0,
                                      stopSell: false,
                                      closedArrival: false,
                                      closedDeparture: false,
                                    })
                                  }
                                  color="primary"
                                  size="xs"
                                  outline
                                  type="button"
                                >
                                  + Add More
                                </Button>
                                {values.restrictions.length > 1 && (
                                  <Button
                                    style={{ margin: '6px' }}
                                    onClick={() => arrayHelpers.remove(index)}
                                    color="secondary"
                                    size="xs"
                                    outline
                                    type="button"
                                  >
                                    -
                                  </Button>
                                )}
                              </div>
                            </Colxx>
                          </Row>
                        </Fragment>
                      ))}
                    </>
                  )}
                />
              </ModalBody>

              <ModalFooter>
                <Button color="primary" type="submit">
                  Update
                </Button>
                <Button color="secondary" onClick={toggleModal} type="button">
                  Cancel
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* Validation error modal */}
      <Validation
        open={open}
        messages={msg}
        toggle={() => setOpen(!open)}
      />
    </div>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return { propertyId };
};

export default injectIntl(connect(mapStateToProps, {})(RestrictionsEditModal));
